import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { loadUserData, loadingPage, selectUser } from "store/slices/app";
import MyAccountMain from "components/myAccount/MyAcoountMain";
import * as usersApi from "api/endpoints/users";
import * as authApi from "api/endpoints/auth";

export default function MyAccountPage() {
  const [selectedTab, setSelectedTab] = useState("1");
  const [userData, setUserData] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [countDownLogout, setCountDownLogout] = useState(5);
  const [loading, setLoading] = useState(false);
  const [loadingReset, setloadingReset] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    loadUserProfile();
  }, []);

  useEffect(() => {
    setShowNotification(false);
  }, [user.selectedPartner.id]);

  function handleTabChange(_, newValue) {
    setSelectedTab(newValue);
    setShowNotification(false);
  }

  async function loadUserProfile() {
    const userData = await usersApi.getUserProfile();
    setUserData(userData?.data);
  }

  async function handleSubmit(data) {
    dispatch(loadingPage(true));
    setLoading(true);
    setShowNotification(false);
    const request = {
      firstName: data?.firstName || "",
      lastName: data?.lastName || "",
      jobTitle: data?.jobTitle || "",
      phone: data?.phone || "",
      isEmailEnabled: data?.isEmailEnabled,
      isSMSEnabled: data?.isSMSEnabled
    };

    try {
      await usersApi.updateUserProfile(request);
      loadUserProfile();
      dispatch(loadUserData());
      setShowNotification({ type: "success", message: "Successfully Updated" });
    } catch (error) {
      setShowNotification({ type: "error", message: "Something went wrong. Please try after some time." });
    } finally {
      setLoading(false);
      dispatch(loadingPage(false));
    }
  }

  async function handlePasswordChange(data) {
    dispatch(loadingPage(true));
    setloadingReset(true);
    try {
      setShowNotification(false);
      await authApi.changePassword(data.oldPassword, data.confirmPassword);
      usersApi.triggerEmail();
      setDialogOpen(true);
    } catch (error) {
      if (error.name === "NotAuthorizedException") {
        setShowNotification({ type: "error", message: "Old password isn’t correct, please try again" });
      } else {
        setShowNotification({ type: "error", message: error.message });
      }
    } finally {
      setloadingReset(false);
      dispatch(loadingPage(false));
    }
  }

  useEffect(() => {
    if (dialogOpen) {
      let myInterval = setInterval(() => {
        if (countDownLogout > 0) {
          setCountDownLogout((prevState) => prevState - 1);
        } else {
          handleClose();
          clearInterval(myInterval);
        }
      }, 1000);
      return () => {
        clearInterval(myInterval);
      };
    }
  });

  async function handleAlertClose(name) {
    switch (name) {
      case "aci":
        setShowNotification({ type: "", message: "" });
        break;
      case "acs":
        break;

      default:
        break;
    }
  }

  function handleClose() {
    setDialogOpen(false);
    navigate("/sign-in");
  }

  return (
    <MyAccountMain
      loading={loading}
      loadingReset={loadingReset}
      selectedTab={selectedTab}
      showNotification={showNotification}
      userData={userData}
      onhandleTabChange={handleTabChange}
      onSubmit={handleSubmit}
      onChangePassword={handlePasswordChange}
      dialogOpen={dialogOpen}
      countDownLogout={countDownLogout}
      onClose={handleClose}
      onAlertClose={handleAlertClose}
    />
  );
}
